'use client';
import { useRef, useState } from 'react';
import Skeleton from '@/components/atoms/skeletons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { mapModifiers } from '@/utils/funtion';
import Empty from '@/components/atoms/empty';
import { useGetCategories } from '@/helpers/useGetCategories';
import Icon from '@/components/atoms/icon';
import Image from 'next/image';
import { FiCameraOff } from 'react-icons/fi';
import { CategoryTags } from '../category-list/catergory-tag';
import Link from 'next/link';
import { PATH_URL } from '@/statics/static';
import { useData } from '@/stores/context';
import { IArticleItem } from '@/interfaces/article';
interface ArticleListProps {
  hasCategory?: boolean;
  hasTitle?: boolean;
  articleSlideList: any;
}

export default function ArticleSlides({
  hasCategory = false,
  hasTitle,
  articleSlideList,
}: ArticleListProps) {
  const { categoryList, isLoading: isLoadingGetCategories } =
    useGetCategories();
  const { innerWidth } = useData();
  const swiperRef = useRef<any>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSwiperUpdate = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // const categoryIds = useMemo(() => [], []);
  // const { articleList, isLoading } = useGetArticles(
  //   1,
  //   articlePageSize,
  //   categoryIds,
  // );

  return (
    <div className="t-article-slides">
      {hasTitle && <div className="t-article-slides_title">Mới nhất</div>}
      <div className="t-article-slides_tags">
        {isLoading && hasCategory
          ? Array(8)
              ?.fill(null)
              .map((_, index) => (
                <div className="t-article-slides" key={index}>
                  <Skeleton
                    style={{
                      width: Math.floor(Math.random() * 160),
                      height: 27,
                      minWidth: 50,
                    }}
                    type="node"
                    active
                    loading
                  />
                </div>
              ))
          : hasCategory && <CategoryTags data={categoryList?.records} />}
      </div>

      {isLoading ? (
        <div
          className={mapModifiers(
            't-article-slides_post',
            innerWidth < 960 ? 'mobile' : '',
          )}
        >
          {Array(innerWidth < 960 ? 3 : 7)
            ?.fill(null)
            .map((_, index) => (
              <div className="t-article-slides_post_item" key={index}>
                <Skeleton
                  style={{
                    width: innerWidth < 960 ? '30vw' : '16vw',
                    height: innerWidth < 960 ? undefined : 407,
                  }}
                  type="node"
                  active
                  loading
                />
              </div>
            ))}
        </div>
      ) : (
        <div className="t-article-slides_swiper">
          <div className="t-article-slides_swiper_nav">
            <div
              onClick={() => swiperRef?.current?.swiper.slidePrev()}
              className={mapModifiers(
                't-article-slides_swiper_nav_prev t-article-slides_swiper_nav_btn',
                isBeginning ? 'disabled' : '',
              )}
            >
              <FiChevronLeft />
            </div>
            <div
              onClick={() => swiperRef?.current?.swiper.slideNext()}
              className={mapModifiers(
                't-article-slides_swiper_nav_next t-article-slides_swiper_nav_btn',
                isEnd ? 'disabled' : '',
              )}
            >
              <FiChevronRight />
            </div>
          </div>
          <Swiper
            ref={swiperRef}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={3}
            spaceBetween={0}
            effect="coverflow"
            speed={800}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 200,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[EffectCoverflow, Pagination]}
            breakpoints={{
              340: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1090: { slidesPerView: 3 },
            }}
            onSlideChange={(swiper) => handleSwiperUpdate(swiper)}
            onSwiper={(swiper) => handleSwiperUpdate(swiper)}
            onTransitionEnd={(swiper) => handleSwiperUpdate(swiper)}
          >
            {!articleSlideList?.records?.length ? (
              <SwiperSlide>
                <Empty />
              </SwiperSlide>
            ) : (
              articleSlideList?.records?.map((item: any) => (
                <SwiperSlide key={item.id}>
                  <ArticleSlideItem item={item} />
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
      )}
    </div>
  );
}

const ArticleSlideItem = ({ item }: { item: IArticleItem }) => {
  return (
    <Link
      key={item.id}
      className="t-article-slide-item"
      href={`${PATH_URL.ARTICLE_URL}/${item?.slug}?id=${item?.id}`}
    >
      <div className="t-article-slide-item_thumb">
        {item?.thumbnail != '' && item?.thumbnail ? (
          <Image
            src={item.thumbnail}
            alt=""
            fill
            style={{ objectFit: 'cover' }}
            loading="lazy"
          />
        ) : (
          <div className="t-article-slide-item_thumb_no-img">
            <Icon component={<FiCameraOff size={40} />} />
          </div>
        )}
      </div>
    </Link>
  );
};
